import EventsPage from "components/EventsPage/EventsPage";

const Events = () => {
	return <EventsPage />;
};

export default Events;
